import type { AiModelPayload } from '@Application/Ai/AiConfiguration/Models/Actions/aiModelsFetched';

export type AiModelUpdatedPayload = AiModelPayload;

export type AiModelUpdatedAction = {
	type: 'AI_MODEL_UPDATED';
	payload: AiModelUpdatedPayload;
	accountId: number;
};

export default (payload: AiModelUpdatedPayload, accountId: number): AiModelUpdatedAction => ({
	type: 'AI_MODEL_UPDATED',
	payload,
	accountId,
});
